export default __webpack_public_path__ + "static/media/logo.7fc8e315.jpg";